export const contracts = {
  multicall: {
    address: "0xc0F5345C65eda3016510A278BBfC0CD7F063c0FE",
  },
  liquidityMiningManager: {
    address: "0xF4cC7b898F96632A4b50b8917617a633b0f85f71",
  },
  escrowedReward: {
    address: "0x73cc0bAF79CcB12AD661725377474ED6a1366fb6",
  },
  view: {
    address: "0x3CD8AD561cc3C40aF80A6c6d10e13482063aC0b9",
  },
  singleTokenPool: {
    address: "0x29eFe3a9509BE192642892601b1e25b9AC4359De",
  },
  lpPool: {
    address: "0x2D9Fd7ad43E75d1f991de6cc876D2285cf8CcBf0",
  },
  uniswapLpPairAddress : {
    address: "0xFCDAe8af3527fC204a1A33542F73dEdE387be03c"
  }
};
